import {AnnualFeeDeduction, Invoice, InvoiceOrAnnualFeeDeduction} from "../../dto/invoice";
import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-customer-invoice-log-view',
  templateUrl: './customer-invoice-log-view.component.html',
  styleUrls: ['./customer-invoice-log-view.component.css']
})


export class CustomerInvoiceLogViewComponent implements OnInit, OnChanges {
  @Input() invs: Invoice[] = [];
  @Input() annualFeeDeductions: AnnualFeeDeduction[] = [];

  combined: InvoiceOrAnnualFeeDeduction[] = [];

  constructor() {}

  ngOnInit() {
    this.combineAndSort();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['invs'] || changes['annualFeeDeductions']) {
      this.combineAndSort();
    }
  }

  private combineAndSort() {
    const invoicesMapped = this.invs ? this.invs.map(invoice => ({
      isInvoice: true,
      isAnnualFeeDeduction: false,
      invoice,
      annualFeeDeduction: null,
      date: new Date(invoice.creationDate)
    })) : [];

    const deductionsMapped = this.annualFeeDeductions ? this.annualFeeDeductions.map(deduction => ({
      isInvoice: false,
      isAnnualFeeDeduction: true,
      invoice: null,
      annualFeeDeduction: deduction,
      date: new Date(deduction.date)
    })) : [];

    this.combined = [...invoicesMapped, ...deductionsMapped].sort(
      (a, b) => b.date.getTime() - a.date.getTime()
    );
  }
}
